<div class="profile-container">
  <div class="">
      <div class="profile-content">
        <!-- <button class="add-ticket" data-toggle="modal" data-target="#exampleModal">Add Ticket Type</button> -->

          <!-- <div class="personal-details">
              <h4 class="personal-details-title">Ticket Type</h4>
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col">Ticket Type</th>
                    <th scope="col">Version</th>
                    <th scope="col">Publicly Visible</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let x of tickets ;let i = index">
                    <th scope="col">{{i+1}}</th>
                    <th scope="col">{{x.name}}</th>
                    <th scope="col">{{x.version}}</th>
                    <th scope="col">{{x.isPubliclyVisible }}</th>
                  </tr>
                     
                </tbody>
            </table>
          </div> -->

          <div class="personal-details">

            <div class="header-block">
                <div class="header-title">
                  <app-breadcrumb></app-breadcrumb>
                </div>
                <div class="add-block">
                    <div class="search">
                      <form autocomplete="off" >
                        <!-- <i class="bi bi-x-lg"></i> -->
                        <input type="text" (keyup.enter)="getTicketTypeByWildSearch(0,10)" [ngModelOptions]="{standalone: true}" placeholder="search" [(ngModel)]="searchKey">
                      </form>
                      <!-- <i class="bi bi-x-lg" (click)="refreshSearch()" *ngIf="searchKey != ''"></i> -->

                      <i class="bi bi-search" (click)="getTicketTypeByWildSearch(0,10)"></i>
                    </div>
                    <button *ngIf="actionControls.isAdd" title="Add" data-toggle="modal" data-target="#exampleModal"><i class="bi bi-plus-lg"></i> {{ 'generic.add' | translate }}</button>
                    <div class="filter-icon">
                      <i class="bi bi-arrow-clockwise" title="Refresh" (click)="refreshSearch()"></i>
                    </div>
                </div>
            </div>
          
            <table class="table table-striped">
                <thead>
                    <tr>
                      <th style="width: 30%;">{{ 'ticket-type.name' | translate }}</th>
                      <!-- <th style="width: 30%;">Version</th> -->
                      <th style="width: 30%;">{{ 'ticket-type.serviceType' | translate }}</th>
                      <th style="width: 30%;">{{ 'ticket-type.isPubliclyVisible' | translate }}</th>
                      <th style="width: 10%;text-align: center;padding: 0;">{{ 'generic.action' | translate }}</th>
                    </tr>
                </thead>
            </table>
            <div *ngIf="!isLoading">
              <div class="data-view" id="{{ticket.id}}" [ngClass]="{ 'delete-highlight': ticket.ticketTypeId == recordId }" *ngFor="let ticket of tickets | paginate : {
                itemsPerPage: tableSize,
                currentPage: pageNumber,
                totalItems: totalRecords
                }  let i = index">
  
                  <p style="width: 30%;">{{ticket.name || " -- " }}</p>
                  <p style="width: 30%;">{{ticket.serviceType || " -- " }}</p>
                  <!-- <p style="width: 30%;padding-left: 25px;">{{ticket.version}}</p> -->
                  <p style="width: 30%;padding-left: 25px;">{{ticket.isPubliclyVisible? "True" : "False"}} </p>
                  <p class="action-buttons" style="width: 10%;padding-left: 15px;">
                    <i (click)="getTicketTypeById(ticket.ticketTypeId)" title="Edit" *ngIf="actionControls.isModify" data-toggle="modal" data-target="#updateModal" class="bi bi-pencil-square"></i>
                    <i (click)="del(ticket.id,ticket)" title="Delete" data-toggle="modal" *ngIf="actionControls.isDelete" data-target="#deleteModal" class="bi bi-trash3"></i>
                </p>
              </div>
            </div>



            <div class="loader" *ngIf="isLoading">
              <div class="spinner"></div>
          </div>
  
          <div class="loader" *ngIf="!isLoading && tickets.length == 0">
              <div class="no-data">
                  <img src="assets/no-data-6.png" alt="">
                  <p>no data found</p>
              </div>
              
          </div>

          <div class="paginator">
            <p-paginator (onPageChange)="onTableDataChange($event)" [first]="first" [rows]="tableSize" [totalRecords]="totalRecords"
                [showFirstLastIcon]="false" [showCurrentPageReport]="true" currentPageReportTemplate="{first} - {last} of {totalRecords}"></p-paginator>
        </div>
  
        </div>

      </div>
  </div>
</div>


<div class="modal fade" id="exampleModal" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true">
<div class="modal-dialog modal-dialog-centered">
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title" id="exampleModalLabel">{{ 'ticket-type.headings.add' | translate }}
        <span data-dismiss="modal">
          <i class="bi bi-x-lg" (click)="clearData()"></i>
        </span>
      </h5>
    </div>
    <div class="modal-body">

      <div [formGroup]="form">

          <div class="form-group">
              <label>{{ 'ticket-type.name' | translate }} <span class="required">*</span></label>
              <input formControlName="name" type="text" class="form-control">
          </div>

          <!-- <div class="form-group">
              <label>Version</label>
              <input formControlName="version" type="text" class="form-control">
          </div> -->

          <div class="form-group">
            <label>{{ 'ticket-type.serviceType' | translate }}</label>
            <select class="form-control" aria-label="Default select example" formControlName="serviceType">
              <option [value]="service.name" *ngFor="let service of serviceData">{{service.name}}</option>
            </select>
          </div>


          <div class="form-group">
            <label>{{ 'ticket-type.isPubliclyVisible' | translate }}</label>
            <select name="" id="" formControlName="isPubliclyVisible" class="form-control">
              <option [ngValue]="true">True</option>
              <option [ngValue]="false" selected>False</option>
            </select>
        </div>

      </div>

 
    <div class="modal-footer">
      <button type="button" id="closeModalButton" (click)="clearData()" class="btn btn-secondary" data-dismiss="modal">{{ 'generic.cancel' | translate }}</button>
      <button type="button" (click)="addTicketType()" class="btn btn-primary">{{ 'generic.add' | translate }}</button>
    </div>
  </div>
</div>
</div>
</div>


<div class="modal fade" id="deleteModal" tabindex="-1" data-backdrop="static" aria-labelledby="deleteModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="deleteModalLabel">{{ 'generic.confirmation' | translate }}
          <span data-dismiss="modal">
            <i class="bi bi-x-lg" (click)="clearData()"></i>
          </span>
        </h5>
      </div>
      <div class="modal-body">
        <p>{{ 'generic.deleteText' | translate }}  <span class="delete-span">“{{recordName}}”</span>?</p>
        <div class="modal-footer">
          <button type="button" id="closeModalButton1" (click)="clearData()" class="btn btn-secondary" data-dismiss="modal">{{ 'generic.cancel' | translate }}</button>
          <button type="button" (click)="deleleTicketType()" class="btn btn-primary">{{ 'generic.delete' | translate }}</button>
        </div>
    </div>
  </div>
</div>
</div>


<div class="modal fade" id="updateModal" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">{{ 'ticket-type.headings.edit' | translate }}
          <span data-dismiss="modal">
            <i class="bi bi-x-lg" (click)="clearData()"></i>
          </span>
        </h5>
      </div>
      <div class="modal-body">
  
        <div [formGroup]="editForm">
  
            <div class="form-group">
                <label>{{ 'ticket-type.name' | translate }}</label>
                <input formControlName="name" type="text" class="form-control">
            </div>
  
            <!-- <div class="form-group">
                <label>Version</label>
                <input formControlName="version" type="text" class="form-control">
            </div> -->
<!--   
            <div class="form-group">
                <label>Active status</label>
                <input type="checkbox" style="margin-left: 10px;" (click)="radiocheck()" formControlName="isActive">
            </div> -->

            <div class="form-group">
              <label>{{ 'ticket-type.serviceType' | translate }}</label>
              <select class="form-control" aria-label="Default select example" formControlName="serviceType">
                <option [value]="service.name" *ngFor="let service of serviceData">{{service.name}}</option>
              </select>
            </div>

            <div class="form-group">
              <label>{{ 'ticket-type.isPubliclyVisible' | translate }}</label>
              <select name="" id="" formControlName="isPubliclyVisible" class="form-control">
                <option [ngValue]="true">True</option>
                <option [ngValue]="false">False</option>
              </select>
          </div>
  
        </div>
  
   
      <div class="modal-footer">
        <button type="button" id="closeModalButton2" (click)="clearData()" class="btn btn-secondary" data-dismiss="modal">{{ 'generic.cancel' | translate }}</button>
        <button type="button" (click)="updateTicketType()" class="btn btn-primary">{{ 'generic.update' | translate }}</button>
      </div>
    </div>
  </div>
  </div>
  </div>